
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partner]/v2",
      function () {
        return require("private-next-pages/[partner]/v2/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[partner]/v2"])
      });
    }
  